import { ActionElement, QueryBuilder, RuleGroupTypeIC } from 'react-querybuilder';
import { QueryBuilderDnD } from '@react-querybuilder/dnd';
import RemoveAction from '../QueryBuilder/RemoveAction';
import React, { useState } from 'react';
import * as ReactDnD from 'react-dnd';
import * as ReactDndHtml5Backend from 'react-dnd-html5-backend';
import TextField from '@mui/material/TextField';
import DropdownAutocomplete from '@/components/FormFields/DropdownAutocomplete';

/**
 * User Agent criteria (ZET-5033). Same rule shape as URL Parameters so the server's rule evaluator
 * is reused, but the field is fixed (the request's User-Agent header) and the match is a
 * case-insensitive "contains" on text the Zuul user types, e.g. "Read Aloud".
 */
export const USER_AGENT_FIELD = 'user_agent';

export const USER_AGENT_OPERATORS = [
  { name: 'contains', label: 'contains' },
  { name: 'does not contain', label: 'does not contain' },
];

const CustomOperatorSelector = (props: any) => {
  const currentLabel = USER_AGENT_OPERATORS.find((op) => op.name === props.value)?.label ?? props.value;
  return (
    <DropdownAutocomplete
      value={currentLabel}
      options={USER_AGENT_OPERATORS.map((op) => op.label)}
      onChange={(label: string) => {
        const op = USER_AGENT_OPERATORS.find((o) => o.label === label);
        if (op) props.handleOnChange(op.name);
      }}
      onBlur={props.onBlur}
      sx={{ width: '100%' }}
    />
  );
};

const CustomValueEditor = (props: any) => (
  <TextField
    type='text'
    value={props.value || ''}
    placeholder='text the user agent contains, e.g. Read Aloud'
    onChange={(e) => props.handleOnChange(e.target.value)}
    onBlur={props.onBlur}
    sx={{ width: '100%' }}
  />
);

const CustomCombinatorSelector = (props: any) => (
  <DropdownAutocomplete
    value={props.value.toUpperCase()}
    options={['AND', 'OR']}
    onChange={(value) => props.handleOnChange(value)}
    onBlur={props.onBlur}
    sx={{ width: '100px', flexShrink: 0 }}
  />
);

export const UserAgent = (props: any) => {
  const defaultQuery: RuleGroupTypeIC = {
    rules: [{ field: USER_AGENT_FIELD, operator: 'contains', value: '' }],
  };

  const [query, setQuery] = useState<RuleGroupTypeIC>(props?.input?.value || defaultQuery);
  const { onChange } = props.input;

  const handleQueryChange = (newQuery: RuleGroupTypeIC) => {
    setQuery(newQuery);
    onChange(newQuery);
  };

  return (
    <div className='queryBuilder'>
      <QueryBuilderDnD dnd={{ ...ReactDnD, ...ReactDndHtml5Backend }}>
        <QueryBuilder
          fields={[{ name: USER_AGENT_FIELD, label: 'User Agent' }]}
          operators={USER_AGENT_OPERATORS}
          query={query}
          onQueryChange={handleQueryChange}
          independentCombinators={true}
          disabled={props.disabled}
          controlElements={{
            fieldSelector: () => null,
            operatorSelector: CustomOperatorSelector,
            valueEditor: CustomValueEditor,
            combinatorSelector: CustomCombinatorSelector,
            addGroupAction: (aeProps) => (aeProps.level === 0 ? <ActionElement {...aeProps} /> : null),
            removeRuleAction: RemoveAction,
            removeGroupAction: RemoveAction,
          }}
          addRuleToNewGroups
          getDefaultField={() => USER_AGENT_FIELD}
          getDefaultOperator={() => 'contains'}
          getDefaultValue={() => ''}
        />
      </QueryBuilderDnD>
    </div>
  );
};
